export { renderRatingDisplay_unstable as renderRatingDisplay } from '@fluentui/react-rating';
